import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useOutlet } from 'react-router-dom';

import HeaderHome from '../home/HeaderHome';

const LayoutManage = () => {
  const outlet = useOutlet();
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <HeaderHome />
      <Content style={{ margin: '16px 100px' }}>{outlet}</Content>
    </Layout>
  );
};

export default LayoutManage;
